// extracted by mini-css-extract-plugin
export var ar = "Modal-module--ar--0ZXYl";
export var button__close = "Modal-module--button__close--4S4G8";
export var button__control = "Modal-module--button__control--GAiRU";
export var button__next = "Modal-module--button__next--7-0Dt";
export var button__previous = "Modal-module--button__previous--8NSUY";
export var container = "Modal-module--container--1VH7-";
export var containerNarrow = "Modal-module--container-narrow--8NUlf";
export var containerWide = "Modal-module--container-wide--Z5gSX";
export var content = "Modal-module--content--eHyy4";
export var fontDisplay = "Modal-module--font-display--jHhBu";
export var fontSansSerif = "Modal-module--font-sans-serif--PEIIr";
export var hover = "Modal-module--hover--FOy4P";
export var linkUl = "Modal-module--link-ul--QXdg2";
export var lock = "Modal-module--lock--a665T";
export var mainInner = "Modal-module--main-inner--k+F0K";
export var onlyForMedium = "Modal-module--only-for-medium--mcnXh";
export var onlyForSmall = "Modal-module--only-for-small--3CDZY";
export var overlay = "Modal-module--overlay--HpNFj";
export var pageTitleWrapper = "Modal-module--page-title-wrapper--5ntD5";
export var spFull = "Modal-module--sp-full--LawR3";
export var textCenter = "Modal-module--text-center----RQp";
export var textLeft = "Modal-module--text-left--jbpbe";
export var textRight = "Modal-module--text-right---Onsi";